<div style="padding: 20px">
  <h4>Are you sure to unlink lawyer {{data.lawyer.firstName}} {{data.lawyer.lastName}}?</h4>
  <div style="width: 100%; display: flex; justify-content: space-between">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-button (click)="unlinkLawyer()" style="background: #be0000; color: #fff">Unlink</button>
  </div>
</div>
